var map = {
	"./1.jpg": 4878,
	"./10.jpeg": 6365,
	"./11.jpeg": 8102,
	"./12.jpeg": 2960,
	"./13.jpeg": 6492,
	"./2.jpg": 8585,
	"./3.jpg": 3212,
	"./4.jpg": 7559,
	"./5.jpg": 3098,
	"./6.jpg": 5701,
	"./7.jpg": 3336,
	"./8.jpeg": 4492,
	"./9.jpeg": 8579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8819;